module.exports = __webpack_public_path__ + "img/DE01856.961acd26.png";